import { render, staticRenderFns } from "./logistics-view.vue?vue&type=template&id=797ee7ee&scoped=true&"
import script from "./logistics-view.vue?vue&type=script&lang=js&"
export * from "./logistics-view.vue?vue&type=script&lang=js&"
import style0 from "./logistics-view.vue?vue&type=style&index=0&id=797ee7ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797ee7ee",
  null
  
)

export default component.exports